import React from 'react';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { GridCustomHeaderCellProps } from '@progress/kendo-react-grid';
import { HeaderCell } from './customCells/HeaderCell';

export const withFilterDescriptor = (filterDescriptor?: CompositeFilterDescriptor) => {
  return (props: GridCustomHeaderCellProps): React.ReactElement => (
    <HeaderCell
      field={props.field}
      title={props.title}
      selectionValue={props.selectionValue}
      selectionChange={props.selectionChange}
      columnMenuWrapperProps={props.columnMenuWrapperProps}
      thProps={props.thProps}
      children={props.children}
      compositeFilterDescriptor={filterDescriptor}
    />
  );
};
